// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import HouseDetailsActionType from './house-details.types';

const INITIAL_STATE = {
	houseResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** update House Details Start ************************/
		case HouseDetailsActionType.HOUSE_DETAILS_CREATE_SUCCESS:
			return { ...state, houseResponse: action.payload };

		case HouseDetailsActionType.HOUSE_DETAILS_CREATE_FAILURE:
			return { ...state, houseResponse: action.payload };

		case HouseDetailsActionType.HOUSE_DETAILS_CREATE_RESPONSE_CHANGED:
			return { ...state, houseResponse: null };
		/** ***************** update House Details End ************************/

		default:
			return state;
	}
};
